import {useState,useEffect} from "react";
import "../../style/scss/App.scss";
import { Form, FormActions, FormCheckbox, FormInput, FormSelect, FormTextArea } from "../Controls/Form";
import BreadCrumb from "../Controls/BreadCrumb";
import Helpers from "../Controls/helpers";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import JobPostingListItem from "../ListItems/JobPostingListItem";
import UserData from "../Controls/UserData";
import PackageSelectionListItem from "../ListItems/PackageSelectionListItem";
import SkillSearch from "../Controls/SkillSearch";
import SkillLevelListItem from "../ListItems/SkillLevelListItem";
import Help from "../Controls/Help";
import API from "@src/API.js";
import { MdAddBox } from "react-icons/md";
import { toast } from "react-toastify";

export default function EmployerRoleEdit(props) {
   const { id: idStr } = useParams();
   const navigate = useNavigate();
   const location = useLocation();
   const [lookups] = useState(UserData.Lookups());
   // Route param is the employer role id (legacy code named this empID).
   const [empID] = useState(Number.parseInt(idStr, 10) || 0);
   const [role, updateRole] = useState({ SkillIDs: [], Skills: [] });
   const [breadcrumb, UpdateBreadcrumb] = useState([]);
   const recruitEmployerId =
      role.EmployerID ||
      location.state?.employer?.ID ||
      location.state?.employerID ||
      0;
   
   const onDone = (e) => {
      return onSave(e).then((res) => {
         Return();
      });
   };
   const onSave = () => {
      const resp = API.postAsync("/PostEmployerRole", role);
      return resp;
   };
   const Return = () => {
      return new Promise((resolve, reject) => {
         navigate(-1);
         resolve(true);
      });
   };
   useEffect(() => {
         let url = "/employer/Role";
         if (empID === 0) 
            url = url + "?employerID=" + props.location.state.employerID;
          else 
            url = url + "?id=" + empID;
         const resp = API.getAsync(url);
         if (resp && resp.ok) {
            var bc = props.location.state.breadcrumb;
            if (bc && bc.length > 0) {
               if (!bc[bc.length - 1].label.startsWith("Edit Role:")) {
                  bc.push({ label: "Edit Role: " + resp.jsonData.Title || "", route: window.location.pathname });
                  UpdateBreadcrumb(bc);
               }
            }
            updateRole(resp.jsonData);
         }
      },
      [props.location.state.employerID, props.location.state.breadcrumb, empID]
   );
   const onDelete = () => {
      UserData.Delete("employerRoleEdit", props.id).then(() => {
         toast.success( "Item deleted");
         Return();
      });
   };
   const togglePackage = (id) => {
      let pkgs = role.Packages;
      let pkg = Helpers.findWithAttr(pkgs, "ID", id);
      if (pkg) {
         pkg.Selected = !pkg.Selected;
      }
      updateRole({ ...role, Packages: pkgs });
   };
   const onChange = (value, field, type, e) => {
      if (type.toLowerCase() === "skillsearch") {
         // let skillIDs = role.SkillIDs;
         let existing = role.Skills.find((e) => {
            return e.SkillID === value.id;
         });
         let skills = role.Skills;
         if (!existing) {
            skills.push({
               SkillID: value.id,
               SkillName: value.shortName || value.Name,
               Level: 3,
               Required: false,
               obj: value,
            });
            updateRole({ ...role, Skills: skills });
         }
      }
   };
   const onLevelSet = (level, id, e) => {
      let skills = role.Skills;
      let skill = Helpers.findWithAttr(skills, "SkillID", id);
      if (skill) {
         skill.Level = level;
      }
      updateRole({ ...role, Skills: skills });
   };
   const onToggleRequired = (id, e) => {
      let skills = role.Skills;
      let skill = Helpers.findWithAttr(skills, "SkillID", id);
      if (skill) {
         skill.Required = !skill.Required;
      }
      updateRole({ ...role, Skills: skills });
   };
   return (
      <>
         <BreadCrumb props={breadcrumb} />
         <Form object={role} onUpdate={updateRole}>
            <h2>Employer Role</h2>
            <FormInput field="title" label="Title" />
            <FormInput field="internalJobCode" label="Internal Job Code" />
            {/* <FormSelect label="Package" field="packageID" valueProp="ID" labelProp="Name" options={role.Packages || []} /> */}
            <FormCheckbox field="onSiteRequired" label="Must be performed on site" />
            <FormSelect
               label="Employment Type"
               field="employmentTypeID"
               options={lookups.employmentType}
               labelProp="Value"
               valueProp="Key"
            />
            <FormTextArea
               field="packageDescription"
               label={"Package Description (" + (role.PackageDescription || "").length + " of 4096)"}
            />
            <FormActions
               onDoneAsync={async (e) => { await onDone(e); }}
               onCancelAsync={async (e) => { await Return(e); }}
               onDeleteAsync={async () => { await onDelete(e); }}
               onSaveAsync={async (e) => { await onSave(e); }}
            />

            <SkillSearch label="Search for skill to add:" onChange={onChange} />
            <Help id="2124" />
            <div className="section">
               <div className="listTitle">
                  <span>
                     Skills for this role:
                     <Help id="2123" />
                  </span>
               </div>
               <div className="sectionData">
                  <ul>
                     {role.Skills
                        ? role.Skills.map((skill) => {
                           return (
                              <li key={skill.Key}>
                                 <SkillLevelListItem
                                    skill={skill}
                                    onChange={onLevelSet}
                                    onDeleteAsync={async (e) => { await onDelete(e); }}
                                    onToggleRequired={onToggleRequired}
                                 />
                              </li>
                           );
                        })
                        : ""}
                  </ul>
               </div>
            </div>
            <div className="section">
               <div className="listTitle">
                  <span>
                     Package(s) available to those entering this role:
                     <Help id="2125" />
                  </span>
               </div>
               <div className="sectionData">
                  <ul>
                     {role.Packages
                        ? role.Packages.map((pkg) => {
                           return (
                              <li key={pkg.id}>
                                 <PackageSelectionListItem
                                    id={pkg.id}
                                    name={pkg.Name}
                                    selected={pkg.Selected}
                                    onClick={togglePackage}
                                 />
                              </li>
                           );
                        })
                        : ""}
                  </ul>
               </div>
            </div>
         </Form>
         <div className="section">
            <div className="listTitle">
               <span>
                  Currently Active Job Postings for this role
                  <Help id="2126" />
               </span>
               <div className="listTitleIcons">
                  <MdAddBox
                     data-testid="job-posting-add"
                     role="button"
                     aria-label="Add job posting"
                     onClick={() =>
                        navigate(`/employerRecruitEdit/${recruitEmployerId}`, {
                           state: {
                              breadcrumb,
                              jobPostingModalId: 0,
                              roleId: role.id || role.ID,
                           },
                        })
                     }
                  />
               </div>
            </div>
            <div className="sectionData">
               <ul>
                  {role.Postings
                     ? role.Postings.filter((e) => e.EmployerRoleID === role.id).map((post) => {
                        return (
                           <li key={post.id || post.ID}>
                              <JobPostingListItem
                                 post={post}
                                 employmentTypes={lookups.employmentType}
                                 onEdit={(postId) =>
                                    navigate(`/employerRecruitEdit/${recruitEmployerId}`, {
                                       state: {
                                          breadcrumb,
                                          jobPostingModalId: postId,
                                       },
                                    })
                                 }
                              />
                           </li>
                        );
                     })
                     : ""}
               </ul>
            </div>
         </div>
      </>
   );
}


